import ExpenseNewForm from "../../Components/Expenses/ExpenseNewForm";
import "../../Components/Style/Expenses/ExpenseNew.css"


function ExpenseNew() {
  return (
    <div className="pages-expense-new">
      <ExpenseNewForm />
    </div>
  );
}

export default ExpenseNew;
